import { render, staticRenderFns } from "./direct-quotation.vue?vue&type=template&id=73785c9f"
import script from "./direct-quotation.vue?vue&type=script&lang=js"
export * from "./direct-quotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports